/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	// The require scope
/******/ 	var __webpack_require__ = {};
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
/*!********************************************************!*\
  !*** ./resources/scripts/sections/popup-words/main.js ***!
  \********************************************************/
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__),
/* harmony export */   "popupWords": () => (/* binding */ popupWords)
/* harmony export */ });
var popupWords = function popupWords() {
  var $sections = document.querySelectorAll(".popup-words__mobile");
  if ($sections) {
    $sections.forEach(function ($section) {
      var $popupContainer = $section.querySelector(".word-popup__mobile-container");
      var $triggers = $section.querySelectorAll(".word-container");
      var $popups = $section.querySelectorAll(".word-popup");
      var $close = $section.querySelector(".word-popup__close");

      // Handle popup triggering
      if ($triggers) {
        $triggers.forEach(function ($trigger) {
          // when word is clicked
          $trigger.addEventListener("click", function () {
            $popups.forEach(function ($popup) {
              // reveal popup
              if ($trigger.dataset.index == $popup.dataset.index) {
                $popup.classList.remove("hidden");
                $popupContainer.classList.add("popup-open");
              }
            });
          });
        });
      }

      // Handle popup closing
      if ($close) {
        $close.addEventListener("click", function () {
          // Hide popups
          $popups.forEach(function ($popup) {
            $popup.classList.add("hidden");
          });

          // disable popup styling
          $popupContainer.classList.remove("popup-open");
        });
      }
    });
  }
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (popupWords);
document.addEventListener("DOMContentLoaded", popupWords);
/******/ })()
;